module.exports = __webpack_public_path__ + "static/dynamic-1d42ce844408de8711387c98b2a1f021.png";